import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { CacheService } from '@app/services/cache.service';
import { endOfDay } from 'date-fns';
import { concat, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

  constructor(
    private http: HttpClient,
    private httpHelper: HttpHelper,
    private cache: CacheService) { }

  private readonly cacheKeyPrefix = 'AppSettingsService';
  public useCache = true;

  private getDefaultRequestCulture$: Observable<string>;

  getDefaultRequestCulture(): Observable<string> {
    const cacheKey = `${this.cacheKeyPrefix}-getDefaultRequestCulture`;
    if (this.getDefaultRequestCulture$) {
      return this.getDefaultRequestCulture$;
    } else {
      this.getDefaultRequestCulture$ = this.http.get(`${Constants.API_ENDPOINT}/appsettings/defaultrequestculture`, { responseType: 'text' })
        .pipe(
          tap(data => {
            // Since this is quite static data we can allow this to be cached and returned again to the user for the duration of the day.
            this.useCache && this.cache.set(cacheKey, data, endOfDay(new Date()));
          }),
          catchError(this.httpHelper.handleError({ operation: 'getDefaultRequestCulture', result: null, cacheKey: cacheKey })));

      if (this.useCache) {
        const cachedData = this.cache.get<string>(cacheKey);
        if (cachedData) {
          return concat(of(cachedData), this.getDefaultRequestCulture$);
        }
      }
      return this.getDefaultRequestCulture$;
    }
  }
}
